import { useCallback, useMemo } from 'react';
import {
  selectMeteorologyAgroWBSequentialDVLocation,
  selectMeteorologyAgroWBSequentialDVGroup,
  setLocation,
} from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useLocations from '../../useLocations';

export default function useLocation() {
  const selectedLocation = useSelector(selectMeteorologyAgroWBSequentialDVLocation);

  const selectedGroup = useSelector(selectMeteorologyAgroWBSequentialDVGroup);
  const allLocations = useLocations().locations;
  const locationOptions = allLocations
    ? allLocations.filter((l) => l.groupId === selectedGroup)
    : [];

  const closeAccordion = useMemo(() => buildAccordionClickFunction('location-accordion'), []);

  const onLocationClick = useCallback((location: number) => () => {
    store.dispatch(setLocation(location));
    closeAccordion();
  }, [closeAccordion]);

  return {
    selectedLocation,
    locationOptions,
    onLocationClick,
  };
}
